import { render, staticRenderFns } from "./Cellphone.vue?vue&type=template&id=304bf826&"
import script from "./Cellphone.vue?vue&type=script&lang=js&"
export * from "./Cellphone.vue?vue&type=script&lang=js&"
import style0 from "./Cellphone.vue?vue&type=style&index=0&id=304bf826&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports